export default __webpack_public_path__ + "static/media/stop-details.f94d38d6.svg";